import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BannerTemplateLibrary = lazy(() =>
  import("@scenes/MessageComposition/Banner/BannerTemplateLibrary").then((module) => ({
    default: module.BannerTemplateLibrary,
  }))
);

export const bannerTemplatesNRO: NavigationRoutingObject = {
  section: "templates",
  Component: BannerTemplateLibrary,
  // This feature does not have non-NRO flow so we don't need to check for the NRO component feature flipper.
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  heading: (t: I18nT<"dashboard-navigation">) => t("banner-templates-nro-heading", "Banner Templates"),
  pageNameForTracking: () => "Banner Templates",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("banner-templates-nro-description", "Manage the templates of banner campaigns"),
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return featureOn("banners");
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      // "banners" (plural) does not match the heading "Banner Templates"
      keywords: [t("banner-templates-alt-keyword-1", "Banners templates")],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
